import compose from "compose-function";
import { AppRouter } from "./AppRouter";

export const AppProviders = compose(AppRouter);